import { gql } from '../__generated__/gql';

const SEARCH_AMENITY_GROUPS = gql(`
  query SearchAmenityGroups(
    $orderBy: [AmenityGroupOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: AmenityGroupWhereInput
  ) {
    amenityGroups(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      title
    }
  }
`);

export default SEARCH_AMENITY_GROUPS;
